(() => {
  /**
   * EXAMPLE
   * <property-select>
   *  <select name="property">
   *   <option value="value1">Value 1</option>
   *   <option value="value2">Value 2</option>
   *  </select>
   * </property-select>
   * ...
   * <input type="hidden" name="property" value="value1">
   */

  class PropertySelect extends HTMLElement {
    constructor() {
      super();

      this.container = this.closest("[data-product-section-wrapper]");
      this.select = this.container.querySelector("select");

      const selectName = this.select.getAttribute("name");

      this.hiddenInput = this.container.querySelector(
        `input[name="${selectName}"][type="hidden"]`
      );

      this.hiddenInput.value =
        this.select.value || this.select.options[0].value;
      this.select.addEventListener("change", () => {
        this.hiddenInput.value = this.select.value;
      });
    }
  }

  if (!customElements.get("property-select")) {
    customElements.define("property-select", PropertySelect);
  }

  /**
   * EXAMPLE
   * <ship-date-input selected-variant-id="{{ product.selected_or_first_available_variant }}">
   *  <input type="hidden">
   * </ship-date-input>
   */

  class ShipDateInput extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector("input");
      const selectedVariantID = this.dataset.selectedVariantId;
      const dateEl = document.querySelector(
        `[data-variant-leaddays="${selectedVariantID}"]`
      );
      const date = dateEl.getAttribute("data-variant-ships-date");
      this.input.value = date;
    }
  }

  if (!customElements.get("ship-date-input")) {
    customElements.define("ship-date-input", ShipDateInput);
  }
})();
